import React from 'react';
import { motion } from 'framer-motion';
import { MailIcon, MapPinIcon, LinkedinIcon } from 'lucide-react';
import { ThreeDBackground } from './ThreeDBackground';
export function Contact() {
  return <section id="contact" className="py-24 md:py-32 bg-navy relative overflow-hidden" data-id="element-43">
      {/* Background Glow */}
      <div className="absolute top-1/2 right-0 -translate-y-1/2 w-[800px] h-[800px] bg-radial-gold opacity-40 pointer-events-none" data-id="element-44"></div>

      {/* 3D Animated Background */}
      <ThreeDBackground variant="subtle" data-id="element-45" />

      <div className="max-w-7xl mx-auto px-6 md:px-12 relative z-10" data-id="element-46">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-16 lg:gap-24" data-id="element-47">
          {/* Left Column */}
          <motion.div initial={{
          opacity: 0,
          x: -30
        }} whileInView={{
          opacity: 1,
          x: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.6
        }} className="flex flex-col justify-center" data-id="element-48">
            <div className="w-16 h-px bg-gold mb-6" data-id="element-49"></div>
            <h2 className="font-sans text-gold text-sm uppercase tracking-widest font-medium mb-4" data-id="element-50">
              Get in Touch
            </h2>
            <h3 className="font-serif text-4xl md:text-5xl lg:text-6xl text-white font-medium leading-tight mb-8" data-id="element-51">
              Connect with <br data-id="element-52" />
              Dr. Jensen
            </h3>
            <p className="font-sans text-white/70 text-lg leading-relaxed font-light max-w-md mb-12" data-id="element-53">
              Available for board engagements, strategic advisory roles, and
              executive speaking opportunities. Reach out to discuss how Dr.
              Jensen can bring decades of clinical and corporate governance
              expertise to your organization.
            </p>

            <div className="space-y-6" data-id="element-54">
              <a href="mailto:oletjensen2526@gmail.com" className="flex items-center gap-4 group" data-id="element-55">
                <div className="w-12 h-12 rounded-full border border-gold/30 flex items-center justify-center group-hover:border-gold group-hover:bg-gold/10 transition-all" data-id="element-56">
                  <MailIcon size={20} className="text-gold" data-id="element-57" />
                </div>
                <span className="font-sans text-white/90 text-lg group-hover:text-gold transition-colors" data-id="element-58">
                  oletjensen2526@gmail.com
                </span>
              </a>

              <div className="flex items-center gap-4" data-id="element-59">
                <div className="w-12 h-12 rounded-full border border-gold/30 flex items-center justify-center" data-id="element-60">
                  <MapPinIcon size={20} className="text-gold" data-id="element-61" />
                </div>
                <span className="font-sans text-white/90 text-lg" data-id="element-62">
                  Englewood, Colorado, United States
                </span>
              </div>

              <a href="#" className="flex items-center gap-4 group" data-id="element-63">
                <div className="w-12 h-12 rounded-full border border-gold/30 flex items-center justify-center group-hover:border-gold group-hover:bg-gold/10 transition-all" data-id="element-64">
                  <LinkedinIcon size={20} className="text-gold" data-id="element-65" />
                </div>
                <span className="font-sans text-white/90 text-lg group-hover:text-gold transition-colors border-b border-transparent group-hover:border-gold" data-id="element-66">
                  Connect on LinkedIn
                </span>
              </a>
            </div>
          </motion.div>

          {/* Right Column - Form */}
          <motion.div initial={{
          opacity: 0,
          x: 30
        }} whileInView={{
          opacity: 1,
          x: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.6,
          delay: 0.2
        }} className="bg-navy-rich p-8 md:p-12 border border-gold/20 shadow-2xl" data-id="element-67">
            <h4 className="font-serif text-3xl text-white mb-8" data-id="element-68">
              Send a Message
            </h4>
            <form className="space-y-8" onSubmit={e => e.preventDefault()} data-id="element-69">
              <div className="relative" data-id="element-70">
                <input type="text" id="name" className="w-full bg-transparent border-b border-white/20 py-3 text-white font-sans focus:outline-none focus:border-gold transition-colors peer placeholder-transparent" placeholder="Name" data-id="element-71" />
                <label htmlFor="name" className="absolute left-0 -top-3.5 text-gold/70 text-sm font-sans transition-all peer-placeholder-shown:text-base peer-placeholder-shown:text-white/50 peer-placeholder-shown:top-3 peer-focus:-top-3.5 peer-focus:text-gold peer-focus:text-sm" data-id="element-72">
                  Full Name
                </label>
              </div>

              <div className="relative" data-id="element-73">
                <input type="email" id="email" className="w-full bg-transparent border-b border-white/20 py-3 text-white font-sans focus:outline-none focus:border-gold transition-colors peer placeholder-transparent" placeholder="Email" data-id="element-74" />
                <label htmlFor="email" className="absolute left-0 -top-3.5 text-gold/70 text-sm font-sans transition-all peer-placeholder-shown:text-base peer-placeholder-shown:text-white/50 peer-placeholder-shown:top-3 peer-focus:-top-3.5 peer-focus:text-gold peer-focus:text-sm" data-id="element-75">
                  Email Address
                </label>
              </div>

              <div className="relative" data-id="element-76">
                <input type="text" id="subject" className="w-full bg-transparent border-b border-white/20 py-3 text-white font-sans focus:outline-none focus:border-gold transition-colors peer placeholder-transparent" placeholder="Subject" data-id="element-77" />
                <label htmlFor="subject" className="absolute left-0 -top-3.5 text-gold/70 text-sm font-sans transition-all peer-placeholder-shown:text-base peer-placeholder-shown:text-white/50 peer-placeholder-shown:top-3 peer-focus:-top-3.5 peer-focus:text-gold peer-focus:text-sm" data-id="element-78">
                  Subject
                </label>
              </div>

              <div className="relative" data-id="element-79">
                <textarea id="message" rows={4} className="w-full bg-transparent border-b border-white/20 py-3 text-white font-sans focus:outline-none focus:border-gold transition-colors peer placeholder-transparent resize-none" placeholder="Message" data-id="element-80"></textarea>
                <label htmlFor="message" className="absolute left-0 -top-3.5 text-gold/70 text-sm font-sans transition-all peer-placeholder-shown:text-base peer-placeholder-shown:text-white/50 peer-placeholder-shown:top-3 peer-focus:-top-3.5 peer-focus:text-gold peer-focus:text-sm" data-id="element-81">
                  Message
                </label>
              </div>

              <button type="submit" className="w-full py-4 bg-transparent border border-gold text-gold font-sans font-medium tracking-widest uppercase hover:bg-gold hover:text-navy transition-all duration-300 mt-4" data-id="element-82">
                Submit Inquiry
              </button>
            </form>
          </motion.div>
        </div>
      </div>
    </section>;
}